import React, { useState, useEffect } from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';

import WaitingPermissionCheck from './WaitingPermissionCheck';
import Form from '../pages/Form';
import FormActivate from '../pages/FormActivate';
import Terms from '../pages/Terms';
import Permissions from '../pages/Permissions';
import Install from '../pages/Install';

import NotFound from '../pages/NotFound';
import AlreadyExists from '../pages/AlreadyExists';

import useCases from '../useCases';
import paths from './paths';
import { api } from '../services';

export default function Routes() {
  const location = useLocation();
  const [checkingPermission, setCheckingPermission] = useState(true);
  const [lead, setLead] = useState({
    name: '',
    email: '',
    company: '',
    jobRole: '',
    options: [],
  });

  useEffect(() => {
    (async () => {
      const checkPermissions = await useCases.privateRouteControl();
      const localLead = useCases.getLocalLead();

      if (checkPermissions.reauth) {
        await api.authorizeApp(checkPermissions.code);
        window.location.replace(paths.alreadyExists);
      }

      if (localLead.success) {
        setLead(localLead.data);
      }
      if (checkPermissions.success) {
        setCheckingPermission(false);
      }
    })();
  }, [location.pathname]);

  const PageWrapper = Page => () => (
    <WaitingPermissionCheck
      fetching={checkingPermission}
      Page={<Page lead={lead} />}
    />
  );

  return (
    <Switch>
      <Route path={paths.activate} exact component={PageWrapper(Form)} />
      <Route
        path={paths.activateInstationApp}
        exact
        component={PageWrapper(FormActivate)}
      />
      <Route path={paths.acceptTerms} exact component={PageWrapper(Terms)} />
      <Route
        path={paths.permissions}
        exact
        component={PageWrapper(Permissions)}
      />
      <Route
        path={paths.alreadyExists}
        exact
        component={PageWrapper(AlreadyExists)}
      />
      <Route path={paths.install} exact component={PageWrapper(Install)} />
      <Route component={NotFound} />
    </Switch>
  );
}
